export default "__VITE_ASSET__CoaMRN0p__"